function States() {
    return (
        <div>
            <h2>States</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default States;